import { defineComponent as l, openBlock as n, createElementBlock as o, normalizeClass as a, renderSlot as i } from "vue";
import { SfThumbnailSize as e } from "@storefront-ui/shared";
const r = {
  [e.sm]: "w-5 h-5",
  [e.base]: "w-6 h-6",
  [e.lg]: "w-10 h-10",
  [e.xl]: "w-14 h-14"
}, p = /* @__PURE__ */ l({
  __name: "SfThumbnail",
  props: {
    size: {
      type: String,
      default: e.base
    }
  },
  setup(t) {
    return (s, m) => (n(), o("div", {
      class: a(["rounded-full overflow-hidden bg-clip-content p-0.5", r[t.size]]),
      "data-testid": "chip-thumbnail"
    }, [
      i(s.$slots, "default")
    ], 2));
  }
});
export {
  p as default
};
